/**
 * @ipc/validation · src/schemas/multicard-envelope.ts — zod-обёртка над КАЖДЫМ
 * ответом SDK Multicard (раздел 13, work item 13). SDK `@ipc/multicard`
 * возвращает нетипизированный `data`; здесь оборачиваем схемой перед
 * использованием — кривой ответ → `IntegrationError`, не `unknown` внутрь.
 */
import { z } from 'zod/v4';
import { tiyinAmount, uuidSchema } from '../common/primitives.ts';
import { paymentStatusEnum, paymentServiceEnum } from '../enums/multicard.ts';

/** Общая оболочка ответа Multicard: { success, data } | { success, error }. */
export function multicardEnvelope<T extends z.ZodTypeAny>(dataSchema: T) {
  return z.discriminatedUnion('success', [
    z.object({ success: z.literal(true), data: dataSchema }),
    z.object({
      success: z.literal(false),
      error: z.object({ code: z.string(), details: z.string() }),
    }),
  ]);
}

/** paymentModel (сокращённо — поля, которые реально читаем). Суммы в тийинах. */
export const multicardPaymentModelSchema = z.object({
  uuid: uuidSchema,
  store_id: z.number().int(),
  amount: tiyinAmount,
  invoice_id: z.string(),
  status: paymentStatusEnum,
  checkout_url: z.string().url().nullable(),
  short_link: z.string().nullable(),
  deeplink: z.string().nullable(),
  ps: paymentServiceEnum.nullable(),
  card_pan: z.string().nullable(),
  receipt_url: z.string().nullable(),
  otp_hash: z.string().nullable(),
  payment_time: z.string().nullable(),
  refund_time: z.string().nullable(),
  added_on: z.string(),
  updated_on: z.string().nullable(),
});
export type MulticardPaymentModel = z.infer<typeof multicardPaymentModelSchema>;
